export const pagesEN = {
  home: {
    help: 'Learn More',
    memes: 'Do you like <span class="text-info">MEMEs</span>?',
    nfts: 'Do you like <span class="text-info">NFTs</span>?',
    headline: '<em class="text-info">NFT your MEME</em> today!',
    create: 'NFT your MEME, get it voted into the Top 10 and earn $NUTS!',
    vote: 'Vote for your favourites memes to decide which ones are the best.',
    auction: 'Biweekly, the <em>Top 10</em> most voted memes win <strong><em>$NUTS</em></strong>!',
    docs: 'For more info check out our <a href="https://docs.elrondbet.net/memes/xmemes" target="_blank" class="ms-1 btn btn-sm btn-outline-light">docs <i class="bi bi-box-arrow-up-right"></i></a>',
  },
  notFound: {
    title: '404: Page not found...',
    subtitle: 'There has been an error while trying to display this page',
    link: 'Back to Homepage',
  },
  shutdown: {
    title: '⏳ The Clock Ran Out',
    subtitle: 'Thirty days, no spins, no flips, no hands dealt. The Doomsday Clock hit zero and MEMEverce went dark.',
    body: 'Every game on this site fed the same countdown. Somewhere along the way, everyone just stopped playing - and nobody topped up the clock in time.',
    started: 'The countdown started {date}.',
    revive: 'It is not permanently over. The clock is read live from the chain: one more transaction, anywhere, and the site opens its doors again.',
    cta: 'Play Token Flip to revive it',
  },
};
